import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-filled",
  "use": "icon-filled-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 11 11\" id=\"icon-filled\"><circle cx=\"5.261\" cy=\"5.966\" r=\"4.5\" stroke=\"#20B26C\" /><path stroke=\"#20B26C\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3.06 5.866 1.69 1.688 2.615-2.615\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol